import {
  FULL_SERVICE,
  GLOBAL_CATALOGS,
  TODO_STATUS_CODE,
} from '../../types';

const initialState = {
  tabs: [],
  isLoading: false,
  value: GLOBAL_CATALOGS.Coworking.Resource.List,
  resource: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  cart: {
    sheet: {
      status: TODO_STATUS_CODE.cart,
      gamShareofficeApplyDetailList: [],
    },
    table: {
      list: [],
      total: 100,
      page: 1,
      rowsPerPage: 10,
      pages: 10,
    },
  },


  order: {
    value: 1,
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  receipt: {
    gamShareofficeApplyDetailList: [],
  },

  applyOrder: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  waitOrder: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  draftOrder: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  historyOrder: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  
  
  news: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const officeReducer = function (state = initialState, action) {
  switch (action.type) {
    case GLOBAL_CATALOGS.Coworking.News.List: {
      return {
        ...state,
        news: action.payload
      };
    }
    case FULL_SERVICE.Office.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SERVICE.Office.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    // 
    case FULL_SERVICE.Office.CartTable: {
      return {
        ...state,
        cart: { 
          ...state.cart,
          table: { ...state.cart.table, ...action.payload }
         }
      };
    }
    case FULL_SERVICE.Office.CartSheet: {
      return {
        ...state,
        cart: { 
          ...state.cart,
          sheet: { ...state.cart.sheet, ...action.payload }
        }
      };
    }
    case FULL_SERVICE.Office.Receipt: {
      return {
        ...state,
        receipt: { ...action.payload }
      };
    }
    case FULL_SERVICE.Office.ClearReceipt: {
      return {
        ...state,
        receipt: action.payload
      };
    }
    // 
    case GLOBAL_CATALOGS.Coworking.Service: {
      return {
        ...state,
        tabs: action.payload
      };
    }
    case GLOBAL_CATALOGS.Coworking.Resource.List: {
      return {
        ...state,
        resource: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Coworking.Order.List: {
      return {
        ...state,
        order: { ...action.payload }
      };
    }
    case FULL_SERVICE.Office.Order.Value: {
      return {
        ...state,
        order: { ...state.order, value: action.payload }
      };
    }
    // 申請記錄-我的申請
    case FULL_SERVICE.Office.Order.ApplyList: {
      return {
        ...state,
        applyOrder: { ...action.payload }
      };
    }
    // 申請記錄-我的候補
    case FULL_SERVICE.Office.Order.WaitList: {
      return {
        ...state,
        waitOrder: { ...action.payload }
      };
    }
    // 申請記錄-我的草稿
    case FULL_SERVICE.Office.Order.DraftList: {
      return {
        ...state,
        draftOrder: { ...action.payload }
      };
    }
    // 申請記錄-歷史表單
    case FULL_SERVICE.Office.Order.HistoryList: {
      return {
        ...state,
        historyOrder: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default officeReducer;